import axiosInstance from "../../../components/authentication/helper/axiosApi";
import { ActionTypes } from "../../constants/action-types";
import { toast } from "react-toastify";

export const fetchUserAction = () => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(`/api/user/isAuthenticated/`);
      dispatch({
        type: ActionTypes.SET_USER,
        payload: response.data,
      });
    } catch (error) {}
  };
};

export const fetchProfileAction = (userId) => {

  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(`/api/profiles/${userId}/`);

      dispatch({
        type: ActionTypes.SET_PROFILE,
        payload: response.data,
      });
    } catch (error) {}
  };
};

export const updateProfleAction = (userId, updateData) => {
  return async (dispatch) => {
    try {
      console.log(updateData);
      const response = await axiosInstance.put(
        `/api/profiles/${userId}/`,
        updateData
      );
      console.log(response.data);

      dispatch({
        type: ActionTypes.SET_PROFILE,
        payload: response.data,
      });
      toast.success("Updated successfully!", {
        position: "bottom-left",
        autoClose: 1000,
        hideProgressBar: true,
        newestOnTo: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    } catch (error) {
      toast.error("Failed!", {
        position: "bottom-left",
        autoClose: 1000,
        hideProgressBar: true,
        newestOnTo: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
  };
};

// export const updateProflePicAction = (userId, updateData) => {
//   return async (dispatch) => {
//     try {

//       const response = await axiosInstance.put(
//         `/api/profiles/uploadPicture/${userId}/`,
//         updateData
//       );
//       console.log('Backend Response:', response);
//       dispatch({
//         type: ActionTypes.SET_PROFILE,
//         payload: response.data,
//       });

//       toast.success("Updated successfully!", {
//         position: "bottom-left",
//         autoClose: 1000,
//         hideProgressBar: true,
//         newestOnTo: true,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         progress: undefined,
//         theme: "dark",
//       });
//     } catch (error) {
//       console.log(error);
//       toast.error("Failed!", {
//         position: "bottom-left",
//         autoClose: 1000,
//         hideProgressBar: true,
//         newestOnTo: true,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         progress: undefined,
//         theme: "dark",
//       });
//     }
//   };
// };

// export const updateProflePicAction = (userId, updateData) => {
//   return async (dispatch) => {
//     try {
//       const response = await axiosInstance.put(
//         `/api/profiles/uploadPicture/${userId}/`,
//         updateData
//       );

//       // Log the response to the console
//       console.log('Backend Response:', response);

//       dispatch({
//         type: ActionTypes.SET_PROFILE,
//         payload: response.data,
//       });

//       toast.success("Updated successfully!", {
//         position: "bottom-left",
//         autoClose: 1000,
//         hideProgressBar: true,
//         newestOnTo: true,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         progress: undefined,
//         theme: "dark",
//       });
//     } catch (error) {
//       console.log(error);

//       toast.error("Failed!", {
//         position: "bottom-left",
//         autoClose: 1000,
//         hideProgressBar: true,
//         newestOnTo: true,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         progress: undefined,
//         theme: "dark",
//       });
//     }
//   };
// };

// Modify the backend API to include coordinates in the response
// export const updateProflePicAction = (userId, updateData) => {
//   return async (dispatch) => {
//     try {
//       const response = await axiosInstance.put(
//         `/api/profiles/uploadPicture/${userId}/`,
//         updateData
//       );

//       // Log the response to the console
//       console.log('Backend Response:', response);

//       // Extract coordinates from the response data
//       const coordinates = response.data.coordinates; // Update this based on your API response structure

//       console.log('Six-coordinates:', coordinates);

//       dispatch({
//         type: ActionTypes.SET_PROFILE,
//         payload: response.data,
//       });

//       toast.success("Updated successfully!", {
//         position: "bottom-left",
//         autoClose: 1000,
//         hideProgressBar: true,
//         newestOnTo: true,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         progress: undefined,
//         theme: "dark",
//       });
//     } catch (error) {
//       console.log(error);

//       toast.error("Failed!", {
//         position: "bottom-left",
//         autoClose: 1000,
//         hideProgressBar: true,
//         newestOnTo: true,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         progress: undefined,
//         theme: "dark",
//       });
//     }
//   };
// };


// export const updateProflePicAction = (userId, updateData) => {
//   return async (dispatch) => {
//     try {
//       // Assuming updateData includes image and coordinates properties
//       const { image, coordinates, ...otherData } = updateData;

//       // Create a FormData object to append image file and coordinates
//       const formData = new FormData();
//       formData.append('image', image);

//       // Append coordinates to FormData
//       for (const key in coordinates) {
//         formData.append(key, coordinates[key]);
//       }

//       // Append other data to FormData
//       for (const key in otherData) {
//         formData.append(key, otherData[key]);
//       }

//       const response = await axiosInstance.put(
//         `/api/profiles/uploadPicture/${userId}/`,
//         formData
//       );

//       // Log the response to the console
//       console.log('Backend Response:', response);

//       // Extract coordinates from the response data
//       const updatedCoordinates = response.data && response.data['Six-coordinates'];

//       // Log the coordinates to the console
//       console.log('Updated Coordinates:', updatedCoordinates);

//       dispatch({
//         type: ActionTypes.SET_PROFILE,
//         payload: response.data,
//       });

//       toast.success("Updated successfully!", {
//         position: "bottom-left",
//         autoClose: 1000,
//         hideProgressBar: true,
//         newestOnTo: true,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         progress: undefined,
//         theme: "dark",
//       });
//     } catch (error) {
//       console.log(error);

//       toast.error("Failed!", {
//         position: "bottom-left",
//         autoClose: 1000,
//         hideProgressBar: true,
//         newestOnTo: true,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         progress: undefined,
//         theme: "dark",
//       });
//     }
//   };
// };


// export const updateProflePicAction = (userId, updateData) => {
//   return async (dispatch) => {
//     try {
//       const { image, sixCoordinates, ...otherData } = updateData;

//       const formData = new FormData();
//       formData.append('image', image);

//       for (const key in sixCoordinates) {
//         formData.append(`Six-coordinates[${key}]`, sixCoordinates[key]);
//       }

//       for (const key in otherData) {
//         formData.append(key, otherData[key]);
//       }

//       const response = await axiosInstance.put(
//         `/api/profiles/uploadPicture/${userId}/`,
//         formData
//       );

//       console.log('Backend Response:', response);

//       // Extract coordinates from the response data
//       const updatedCoordinates = response.data && response.data['Six-coordinates'];

//       console.log('Updated Coordinates:', updatedCoordinates);

//       dispatch({
//         type: ActionTypes.SET_PROFILE,
//         payload: response.data,
//       });

//       toast.success("Updated successfully!", {
//         position: "bottom-left",
//         autoClose: 1000,
//         hideProgressBar: true,
//         newestOnTo: true,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         progress: undefined,
//         theme: "dark",
//       });
//     } catch (error) {
//       console.log(error);

//       toast.error("Failed!", {
//         position: "bottom-left",
//         autoClose: 1000,
//         hideProgressBar: true,
//         newestOnTo: true,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         progress: undefined,
//         theme: "dark",
//       });
//     }
//   };
// };


export const updateProflePicAction = (userId, updateData) => {
  return async (dispatch) => {
    try {
      const formData = new FormData();

      // 1️⃣ Append the image file correctly
      if (updateData.profile_image) {
        formData.append("profile_image", updateData.profile_image);
      }

      // 2️⃣ Append coordinates correctly
      if (updateData["Six-coordinates"]) {
        formData.append(
          "Six-coordinates",
          JSON.stringify(updateData["Six-coordinates"])
        );
      }

      const response = await axiosInstance.put(
        `/api/profiles/uploadPicture/${userId}/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Backend Response:", response);

      dispatch({
        type: ActionTypes.SET_PROFILE,
        payload: response.data,
      });

      toast.success("Updated successfully!", {
        position: "bottom-left",
        autoClose: 1000,
        hideProgressBar: true,
      });

    } catch (error) {
      console.log(error);

      toast.error("Upload Failed!", {
        position: "bottom-left",
        autoClose: 1000,
        hideProgressBar: true,
      });
    }
  };
};











// Notifications
export const fetchUserNotificationsAction = () => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `/api/notifications/userNotification/`
      );

      dispatch({
        type: ActionTypes.SET_NOTIFICATIONS,
        payload: response.data,
      });
    } catch (error) {}
  };
};

// Change Password
export const changePasswordAction = (data, id) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.post(
        `/api/user/changePassword/${id}/`,
        data
      );
      dispatch({
        payload: response.data,
      });
    } catch (error) {
      alert(error);
    }
  };
};

export const updatePaidAction = (userId, updateData) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.post(
        `/api/user/is_paid/${userId}/`,
        updateData
      );
      console.log(response);
      dispatch({
        type: ActionTypes.SET_PAID,
        payload: response.data,
      });
    } catch (error) {}
  };
};
